import { render, staticRenderFns } from "./EditTherapy.vue?vue&type=template&id=59c96794"
import script from "./EditTherapy.vue?vue&type=script&lang=js"
export * from "./EditTherapy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports